'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
// Image import removed - using inline SVG

const NAV_LINKS = [
{ label: 'Home', href: '/' },
{ label: 'Episodes', href: '/episodes' },
{ label: 'About', href: '/about' },
{ label: 'Media', href: '/media' },
{ label: 'Contact', href: '/contact' }];


export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = usePathname();

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        backgroundColor: 'rgba(3,5,8,0.9)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid var(--border)'
      }}>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2.5 group" aria-label="True Hauntings home">
            <div className="w-9 h-9 flex items-center justify-center flex-shrink-0">
              <img
                src="https://assets.pippa.io/shows/5f8e56cfe2dbd533ea999829/1768695759339-fd46b5b0-818a-4bcd-8deb-d995b76f3c1f.jpeg"
                alt="True Hauntings podcast show art"
                width={36}
                height={36}
                style={{ borderRadius: '6px', objectFit: 'cover', width: '36px', height: '36px' }} />
              
            </div>
            <div>
              <span
                className="text-sm font-bold tracking-wider"
                style={{ fontFamily: 'var(--font-display)', color: 'var(--foreground)' }}>
                
                True Hauntings
              </span>
              <span
                className="block text-xs"
                style={{ color: 'var(--primary)', fontFamily: 'var(--font-mono)', letterSpacing: '0.1em' }}>
                
                Podcast
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1" aria-label="Main navigation">
            {NAV_LINKS?.map((link) => {
              const active = pathname === link?.href || link?.href !== '/' && pathname?.startsWith(link?.href);
              return (
                <Link
                  key={link?.href}
                  href={link?.href}
                  className="px-4 py-2 text-xs font-semibold tracking-widest uppercase transition-colors min-h-[44px] flex items-center"
                  style={{
                    color: active ? 'var(--primary)' : 'var(--muted-foreground)',
                    fontFamily: 'var(--font-mono)',
                    borderBottom: active ? '1px solid var(--primary)' : '1px solid transparent'
                  }}>
                  
                  {link?.label}
                </Link>);

            })}
          </nav>

          {/* Right side */}
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex items-center gap-2">
              <span className="relative flex h-2 w-2">
                <span
                  className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75"
                  style={{ backgroundColor: 'var(--primary)' }} />
                
                <span
                  className="relative inline-flex rounded-full h-2 w-2"
                  style={{ backgroundColor: 'var(--primary)' }} />
                
              </span>
              <span
                className="text-xs font-mono font-bold tracking-widest uppercase"
                style={{ color: 'var(--muted-foreground)' }}>
                
                New Episodes
              </span>
            </div>
            <a
              href="https://open.spotify.com/show/1FIfOIC08D6v9Y5FP6ud1c"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-xs px-4 py-2"
              style={{ minHeight: '36px' }}>
              
              Follow
            </a>
            <button
              className="md:hidden p-2 transition-colors"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
              style={{ color: 'var(--muted-foreground)' }}>
              
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                {mobileOpen ?
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" /> :

                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                }
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileOpen &&
        <div className="md:hidden border-t py-4" style={{ borderColor: 'var(--border)' }}>
            {NAV_LINKS?.map((link) =>
          <Link
            key={link?.href}
            href={link?.href}
            className="block px-4 py-3 text-xs font-semibold tracking-widest uppercase transition-colors"
            style={{ color: pathname === link?.href ? 'var(--primary)' : 'var(--muted-foreground)', fontFamily: 'var(--font-mono)' }}
            onClick={() => setMobileOpen(false)}>
            
                {link?.label}
              </Link>
          )}
          </div>
        }
      </div>
    </header>);

}